import { CalculationTypeEnum } from '../enums';

export const calculationTypesWithNoAdditionalParams: CalculationTypeEnum[] = [CalculationTypeEnum.Reguard, CalculationTypeEnum.Resource];
